// D367 CUSTOM CODE START:
// Added sticky CTA stock-state controls (Out of stock + disable behavior).
function updateStickyButtonState(variant) {
  if (!variant) return;

  const bar = document.querySelector('.d367-sticky-bar');
  if (!bar) return;

  const cta = bar.querySelector('[data-add-to-cart]');
  if (!cta) return;

  const isAvailable = !!(variant && variant.available);
  const defaultLabel = cta.dataset.defaultLabel || cta.textContent.trim() || 'Add to Cart';

  if (!cta.dataset.defaultLabel) {
    cta.dataset.defaultLabel = defaultLabel;
  }

  const nextLabel = isAvailable ? defaultLabel : 'Out of stock';
  cta.textContent = nextLabel;
  cta.setAttribute('aria-disabled', String(!isAvailable));
  cta.dataset.stockStatus = isAvailable ? 'in-stock' : 'out-of-stock';

  // Handle both <button> and non-button CTA elements.
  if ('disabled' in cta) {
    cta.disabled = !isAvailable;
  }

  cta.style.pointerEvents = isAvailable ? '' : 'none';
  cta.style.opacity = isAvailable ? '' : '0.6';
  cta.style.cursor = isAvailable ? '' : 'not-allowed';
}

function getCurrentVariantFromDom() {
  const variantJsonEl = document.querySelector('[data-variant-json]');
  const idInput =
    document.querySelector('form[action^="/cart/add"] [name="id"]') ||
    document.querySelector('form [name="id"]');

  if (!variantJsonEl || !idInput) return null;

  let variants = [];
  try {
    variants = JSON.parse(variantJsonEl.textContent || '[]');
  } catch (error) {
    return null;
  }

  const selectedId = String(idInput.value || '').trim();
  return variants.find(v => String(v.id) === selectedId) || null;
}
// D367 CUSTOM CODE END.

document.addEventListener('variant:change', function (evt) {
  const variant = evt.detail.variant;
  if (!variant) return;

  const bar = document.querySelector('.d367-sticky-bar');
  if (!bar) return;

  const img = bar.querySelector('.d367-sticky-image');
  const title = bar.querySelector('.d367-sticky-title');
  const variantText = bar.querySelector('.d367-sticky-variant');
  const price = bar.querySelector('.d367-sticky-price-main');
  const mrp = bar.querySelector('.d367-sticky-mrp');
  const discount = bar.querySelector('.d367-sticky-discount');

  /* IMAGE */
  if (variant.featured_image && img) {
    img.src = variant.featured_image.src;
  }

  /* TITLE */
//   if (title) {
//     title.textContent = variant.product_title;
//   }

// if (title && title.textContent.trim() === '') {
//   title.textContent = bar.dataset.productTitle;
// }


  /* VARIANT TITLE */
  if (variantText) {
    variantText.textContent = variant.title;
  }

  /* PRICE */
  if (price) {
    price.innerHTML = theme.Currency.formatMoney(
      variant.price,
      theme.settings.moneyFormat
    );
  }

  /* MRP + DISCOUNT */
  if (
    variant.compare_at_price &&
    variant.compare_at_price > variant.price
  ) {
    if (mrp) {
      mrp.innerHTML =
        'MRP: ' +
        theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.settings.moneyFormat
        );
      mrp.classList.remove('hidden');
    }

    if (discount) {
      const percent = Math.round(
        ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price
      );
      discount.textContent = percent + '%';
      discount.classList.remove('hidden');
    }
  } else {
    if (mrp) mrp.classList.add('hidden');
    if (discount) discount.classList.add('hidden');
  }

  // D367 CUSTOM CODE: sync sticky CTA state to selected variant stock.
  updateStickyButtonState(variant);
});

/* ADD TO CART – Expance compatible */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;

  // D367 CUSTOM CODE: prevent add-to-cart when sticky CTA is in out-of-stock state.
  const isDisabled =
    btn.getAttribute('aria-disabled') === 'true' ||
    btn.dataset.stockStatus === 'out-of-stock' ||
    ('disabled' in btn && btn.disabled);

  if (isDisabled) {
    e.preventDefault();
    return;
  }

  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const submit = form.querySelector('[type="submit"]');
  if (submit) submit.click();
});

// stick hide and show logic
document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('.d367-sticky-bar');
  const buyBtn = document.querySelector('shopify-buy-it-now-button');
  const footer = document.querySelector('.footer_below');

  // D367 CUSTOM CODE: initialize sticky CTA state on first paint.
  updateStickyButtonState(getCurrentVariantFromDom());

  if (!sticky || !buyBtn || !footer) return;

  let buyVisible = true;
  let footerVisible = false;

  function updateSticky() {
    if (!buyVisible && !footerVisible) {
      sticky.classList.remove('is-hidden');
    } else {
      sticky.classList.add('is-hidden');
    }
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.target === buyBtn) {
          buyVisible = entry.isIntersecting;
        }
        if (entry.target === footer) {
          footerVisible = entry.isIntersecting;
        }
        updateSticky();
      });
    },
    { threshold: 0.15 }
  );

  observer.observe(buyBtn);
  observer.observe(footer);
});


